/**
 * The one error type for this package (repo root). See
 * .claude/rules/conventions/failures.md for the full contract.
 * @see failure.test.js
 */
export class Failure extends Error {
  constructor(
    what,
    fix,
    { severity = "error", source = "Error", cause, external, status } = {}
  ) {
    const externalMessage =
      external ??
      (cause instanceof Error
        ? cause.message
        : cause === undefined
          ? null
          : String(cause))
    const message = [
      what,
      `Fix: ${fix}`,
      externalMessage && `${source} said: ${externalMessage}`,
    ]
      .filter(Boolean)
      .join("\n")

    super(message, cause === undefined ? undefined : { cause })
    this.name = "Failure"
    this.severity = severity
    // Who produced the underlying error (e.g. "Worker API", "Browser cookie
    // storage") — lets a caller or log line identify the failing system
    // without re-parsing the message text.
    this.source = source
    // The Worker's HTTP status code, when this Failure wraps a rejected API
    // call (see network.js's apiCall) — lets a caller recognise a specific
    // rejection (e.g. 409) without string-matching the message.
    this.status = status
  }
}
